import LineItem from './LineItem'
/**
  *   Order
  *
  */
class Order {
  
  constructor (content) {
    // import props
    _.extend(this, content);

    // messages linked to the order
    this.info = []

    this.items = []
    
    // map order types
    this.orderTypes = {
      'ORDER': 0,
      'RETURN': 0
    }
  }
    
  //   called just to fill the object, so it just takes
  //   the input and converts it into lineItem
  addItems (lineItems) {
    if (_.isArray(lineItems)) {
      lineItems.forEach(function(singleLineItem) {
        this.addItem(singleLineItem);
      }.bind(this))
    } else {
      this.addItem(lineItems);
    }
  }
    
  /**
  *   addItem
  *   add a LineItem or extend an existing one
  */
  addItem (itemData) {
    if (!itemData.ordered_item && !itemData.item_primary_key && !itemData.line_id) throw 'itemData must carry an ID';
    
    // make sure items it's initialised
    if (!this.items || !_.isArray(this.items)) {
      // console.log(`items on order ${this.order_number} is empty`)
      this.items = [];
    }
    
    // lookup the item in the current order'
    // var lineItemIdx = this.lookupLineByOrderedItem(itemData.ordered_item);
    var lineItemIdx = this.lookupLineByLineId(itemData.line_id);

    // insert or extend an existing line item
    if (lineItemIdx > -1) {
      _.extend(this.items[lineItemIdx], itemData);
    } else {
      this.items.push(new LineItem(itemData));
    }
    
    // update order type counters
    if (itemData.line_category_code) {
      this.orderTypes[itemData.line_category_code]++;
    }
  }
    
  /**
  *   addInfo
  *   stores info or dispatches it to child LineItems
  */
  addInfo (info) {
    _.forEach(info, function (singleInfo, key) {
      // if the key is only numbers we infer the info is related to the corresponding line_item.line_id
      if (/^\d{2,}$/.test(key)) {
        // method will take care of creating/updating the item
        if (_.isArray(singleInfo)) {
          singleInfo.forEach((single) => {
            this.addItem({
              line_id: single.line_id,
              info: {
                notification_type: single.notification_type,
                notification: single.notification,
                notification_type: single.notification_type
              },
            });
          })
        } else {
          this.info.push({
            notification_type: singleInfo.notification_type,
            notification: singleInfo.notification,
            notification_type: singleInfo.notification_type
          });
          // this.addItem({
          //   line_id: singleInfo.order_number,
          //   notification: singleInfo.notification
          // })
        }
      } else {
        // info is order-specific (no line_item key)
        this.info.push({
          notification_type: singleInfo.notification_type,
          notification: singleInfo.notification,
          notification_type: singleInfo.notification_type
        });
      }
    }.bind(this));
  }
  
  /**
  *   lookupLineByOrderedItem
  *   @return idx or -1
  */
  lookupLineByOrderedItem (ordered_item) {
    return _.findIndex(this.items, {
      ordered_item: ordered_item
    });
  }
  
  /**
  *   lookupLineByLineId
  *   @return idx or -1
  */
  lookupLineByLineId (line_id) {
    return _.findIndex(this.items, {
      line_id: line_id
    });
  }
  
  /**
  *   lookupLineById
  *   @return idx or -1
  */
  lookupLineByPrimaryKey (key) {
    return _.findIndex(this.items, {
      item_primary_key: key
    });
  }
  
  /**
  *   hasItemsOfType
  *
  */
  hasItemsOfType (type) {
    return !!this.orderTypes[type] || false;
  }
  
  /**
  *   getItemsByType
  *
  */
  getItemsByType (type) {
    return _.filter(this.items, function(item) {
      return item.line_category_code === type;
    })
  }
}
    
export default Order


// WEBPACK FOOTER //
// ./src/app/modules/Cart/classes/Order.js